/* ET - LP Gift: keeps the gift progress bar in step with the cart (value after discounts, excluding the gift).
   The threshold is stored in the shop currency and converted with Shopify.currency.rate for other markets. */
(function () {
  if (customElements.get('et-gift-progress')) return;

  var separators = {
    amount: [2, ',', '.'],
    amount_no_decimals: [0, ',', '.'],
    amount_with_comma_separator: [2, '.', ','],
    amount_no_decimals_with_comma_separator: [0, '.', ','],
    amount_with_space_separator: [2, ' ', ','],
    amount_no_decimals_with_space_separator: [0, ' ', ','],
    amount_with_period_and_space_separator: [2, ' ', '.'],
    amount_with_apostrophe_separator: [2, "'", '.']
  };

  function formatWithShopFormat(cents, stripZeros) {
    var format = (window.themeVariables && window.themeVariables.settings.moneyFormat) || '€{{amount_with_comma_separator}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholder);
    var rule = separators[match ? match[1] : 'amount'] || separators.amount;
    var parts = (cents / 100).toFixed(rule[0]).split('.');
    var amount = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, rule[1]) + (parts[1] ? rule[2] + parts[1] : '');

    if (stripZeros) amount = amount.replace(/[.,]00$/, '');
    return format.replace(placeholder, amount);
  }

  function formatMoney(cents, rate, stripZeros) {
    if (rate === 1) return formatWithShopFormat(cents, stripZeros);

    /* Other currencies: the cart gift script formats in the shop's own style for the active currency (e.g. 3 402 kr),
       so this bar reads the same as the cart and the product page. */
    if (window.etCartGift && typeof window.etCartGift.formatMoney === 'function') {
      return window.etCartGift.formatMoney(cents);
    }

    try {
      return new Intl.NumberFormat(window.Shopify.locale || document.documentElement.lang || 'nl', {
        style: 'currency',
        currency: window.Shopify.currency.active,
        minimumFractionDigits: stripZeros && cents % 100 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (error) {
      return formatWithShopFormat(cents, stripZeros);
    }
  }

  class EtGiftProgress extends HTMLElement {
    connectedCallback() {
      var currency = window.Shopify && window.Shopify.currency;
      this.rate = (currency && parseFloat(currency.rate)) || 1;
      this.threshold = Math.round(((parseInt(this.dataset.threshold, 10) || 0) * this.rate) / 100) * 100;
      this.message = this.querySelector('[data-et-gift-message]');
      this.thresholdLabel = this.querySelector('[data-et-gift-threshold]');
      this.fill = this.querySelector('[data-et-gift-fill]');
      this.track = this.fill && this.fill.parentElement;

      this.onCartChange = this.onCartChange.bind(this);
      this.onCartRefresh = this.onCartRefresh.bind(this);
      this.onPageShow = this.onPageShow.bind(this);
      this.onVisibilityChange = this.onVisibilityChange.bind(this);
      document.addEventListener('cart:change', this.onCartChange);
      document.addEventListener('cart:refresh', this.onCartRefresh);
      /* Back button (page restored from the browser cache) or a cart changed in another tab */
      window.addEventListener('pageshow', this.onPageShow);
      document.addEventListener('visibilitychange', this.onVisibilityChange);

      if (this.rate !== 1) this.render(parseInt(this.dataset.total, 10) || 0);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:change', this.onCartChange);
      document.removeEventListener('cart:refresh', this.onCartRefresh);
      window.removeEventListener('pageshow', this.onPageShow);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }

    onPageShow(event) {
      if (event.persisted) this.onCartRefresh();
    }

    onVisibilityChange() {
      if (document.visibilityState === 'visible') this.onCartRefresh();
    }

    onCartChange(event) {
      if (event.detail && event.detail.cart) {
        this.render(this.qualifyingTotal(event.detail.cart));
      } else {
        this.onCartRefresh();
      }
    }

    onCartRefresh() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.json();
        })
        .then(
          function (cart) {
            this.render(this.qualifyingTotal(cart));
          }.bind(this)
        )
        .catch(function () {});
    }

    qualifyingTotal(cart) {
      var giftHandle = this.dataset.giftHandle;

      return (cart.items || []).reduce(function (total, item) {
        var isGift = item.handle === giftHandle || (item.properties && item.properties._is_free_gift);
        return isGift ? total - item.final_line_price : total;
      }, cart.total_price || 0);
    }

    render(total) {
      if (!this.message || !this.fill || this.threshold <= 0) return;

      var remaining = Math.max(this.threshold - total, 0);
      var progress = Math.min(Math.floor((total / this.threshold) * 100), 100);

      this.message.textContent =
        remaining > 0
          ? (this.dataset.remainingText || '').replace('[amount]', formatMoney(remaining, this.rate, true))
          : this.dataset.unlockedText || '';

      if (this.thresholdLabel) this.thresholdLabel.textContent = formatMoney(this.threshold, this.rate, true);

      this.fill.style.width = Math.max(progress, 0) + '%';
      if (this.track) this.track.setAttribute('aria-valuenow', Math.max(progress, 0));
    }
  }

  customElements.define('et-gift-progress', EtGiftProgress);
})();
